import * as tslib_1 from "tslib";
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import moveItemsService from '../../services/moveItemsService';
import showNotificationOnMoveOrArchiveSucceeded from './helpers/showNotificationOnMoveOrArchiveSucceeded';
import { action } from 'satcheljs/lib/legacy';
import { mailStore } from 'owa-mail-store';
import folderStore from 'owa-folders';
import datapoints from '../datapoints';
import { isItemOfMessageType } from 'owa-mail-list-store';
import addMovedItemsToUndoStack from './helpers/addMovedItemsToUndoStack';
import handleBlockActionForShadowMailbox from '../helpers/handleBlockActionForShadowMailbox';
import * as undoActions from 'owa-mail-undo';
export default action('moveItemsFromItemIds', datapoints.moveItemsDatapoint)(function moveItemsFromItemIds(itemIds, destinationFolderId, originalTableView, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var sourceFolderId, itemContexts;
        return tslib_1.__generator(this, function (_a) {
            sourceFolderId = originalTableView.tableQuery.folderId;
            if (handleBlockActionForShadowMailbox(sourceFolderId, destinationFolderId)) {
                return [2 /*return*/];
            }
            undoActions.clearLastUndoableAction();
            itemContexts = itemIds.map(function (itemIdValue) {
                var item = mailStore.items.get(itemIdValue);
                var isReadValue;
                if (isItemOfMessageType(item)) {
                    isReadValue = item.IsRead;
                }
                else {
                    // Default to isRead = true when not a mail item
                    isReadValue = true;
                }
                return {
                    itemId: itemIdValue,
                    conversationId: item.ConversationId.Id,
                    isRead: isReadValue,
                };
            });
            // Dispatch action to update the store state
            deleteItemsStoreUpdate(itemContexts, sourceFolderId);
            // Make service request
            return [2 /*return*/, moveItemsService(itemIds, destinationFolderId, sourceFolderId)
                    .then(function (moveItemResponse) {
                    if (moveItemResponse.ResponseMessages) {
                        var numberOfItemsAddedToUndoStack = addMovedItemsToUndoStack(moveItemResponse.ResponseMessages.Items, destinationFolderId, sourceFolderId);
                        if (numberOfItemsAddedToUndoStack > 0) {
                            var isArchiveFolder = destinationFolderId ===
                                getUserConfiguration().UserOptions.ArchiveFolderId;
                            var destinationFolderName = folderStore.folderTable.get(destinationFolderId).DisplayName;
                            showNotificationOnMoveOrArchiveSucceeded(numberOfItemsAddedToUndoStack, destinationFolderName, isArchiveFolder);
                        }
                    }
                })
                    .catch()];
        });
    });
});
//# sourceMappingURL=moveItemsFromItemIds.js.map